<script setup lang="ts">
import { toTypedSchema } from '@vee-validate/zod'
import { ElMessage } from 'element-plus'
import { useForm } from 'vee-validate'
import * as z from 'zod'
import { FormControl, FormField, FormItem, FormMessage } from '@/ui/shadcn/ui/form'

defineOptions({
  name: 'EditPasswordForm',
})

const userStore = useUserStore()

const loading = ref(false)

const form = useForm({
  validationSchema: toTypedSchema(
    z.object({
      old_password: z.string().min(1, '请输入原密码'),
      new_password: z.string()
        .min(1, '请输入新密码')
        .min(6, '密码长度至少6位'),
      confirm_password: z.string().min(1, '请确认新密码'),
    }).refine(data => data.new_password === data.confirm_password, {
      message: '两次输入的密码不一致',
      path: ['confirm_password'],
    }),
  ),
  initialValues: {
    old_password: '',
    new_password: '',
    confirm_password: '',
  },
})

const onSubmit = form.handleSubmit(async (values) => {
  loading.value = true
  try {
    // 转换字段名以匹配 API 要求
    await userStore.editPassword({
      old_password: values.old_password,
      new_password: values.new_password,
      new_password_confirmation: values.confirm_password,
    })
    ElMessage.success('密码修改成功，请重新登录')
    // 延迟1秒后登出
    setTimeout(() => {
      userStore.logout()
    }, 1000)
  }
  catch (error: any) {
    ElMessage.error(error.message || '密码修改失败')
  }
  finally {
    loading.value = false
  }
})
</script>

<template>
  <div class="w-full flex-col-stretch-center">
    <div class="mb-6 space-y-2">
      <h3 class="text-4xl color-[var(--el-text-color-primary)] font-bold">
        修改密码
      </h3>
      <p class="text-sm text-muted-foreground lg:text-base">
        密码长度至少6位
      </p>
    </div>
    <form @submit="onSubmit">
      <FormField v-slot="{ componentField, errors }" name="old_password">
        <FormItem class="relative pb-6 space-y-0">
          <FormControl>
            <FaInput type="password" placeholder="请输入原密码" class="w-full" :class="errors.length && 'border-destructive'" v-bind="componentField" />
          </FormControl>
          <Transition enter-active-class="transition-opacity" enter-from-class="opacity-0" leave-active-class="transition-opacity" leave-to-class="opacity-0">
            <FormMessage class="absolute bottom-1 text-xs" />
          </Transition>
        </FormItem>
      </FormField>
      <FormField v-slot="{ componentField, errors }" name="new_password">
        <FormItem class="relative pb-6 space-y-0">
          <FormControl>
            <FaInput type="password" placeholder="请输入新密码（至少6位）" class="w-full" :class="errors.length && 'border-destructive'" v-bind="componentField" />
          </FormControl>
          <Transition enter-active-class="transition-opacity" enter-from-class="opacity-0" leave-active-class="transition-opacity" leave-to-class="opacity-0">
            <FormMessage class="absolute bottom-1 text-xs" />
          </Transition>
        </FormItem>
      </FormField>
      <FormField v-slot="{ componentField, errors }" name="confirm_password">
        <FormItem class="relative pb-6 space-y-0">
          <FormControl>
            <FaInput type="password" placeholder="请确认新密码" class="w-full" :class="errors.length && 'border-destructive'" v-bind="componentField" />
          </FormControl>
          <Transition enter-active-class="transition-opacity" enter-from-class="opacity-0" leave-active-class="transition-opacity" leave-to-class="opacity-0">
            <FormMessage class="absolute bottom-1 text-xs" />
          </Transition>
        </FormItem>
      </FormField>
      <FaButton :loading="loading" size="lg" class="mt-8 w-full" type="submit">
        保存
      </FaButton>
    </form>
  </div>
</template>
